"use client";

import { logger } from "@utilities/logger";
import posthog from "posthog-js";
import IconEmojiSad from "@ui/central-icons/icons/IconEmojiSad";
import { Button } from "@ui/components/core/Button";
import { HairlineCardBorder } from "@ui/components/core/HairlineCardBorder";
import { useTranslations } from "next-intl";
import type React from "react";
import type { ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

export function BlockErrorBoundary({ children, blockType }: { children: ReactNode; blockType?: string }) {
  return (
    <ErrorBoundary
      fallback={<BlockErrorFallback />}
      onError={(error: Error, info: React.ErrorInfo) => {
        logger.error(error, `Block "${blockType ?? "unknown"}" crashed`, info.componentStack);
        posthog.captureException(error, { blockType, service: "marketing-website", exception_source: "client" });
      }}
    >
      {children}
    </ErrorBoundary>
  );
}

function BlockErrorFallback() {
  const t = useTranslations("ClientKeys.Globals");

  return (
    <div className='tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-rounded-2xl tw-bg-cream tw-px-6 tw-py-16'>
      <HairlineCardBorder />
      <IconEmojiSad className='tw-size-6 tw-text-neutral-400' />
      <div className='tw-flex tw-flex-col tw-items-center tw-gap-1'>
        <p className='tw-text-sm tw-text-neutral-600'>{t("block_error_title")}</p>
        <p className='tw-text-xs tw-text-neutral-400'>{t("block_error_description")}</p>
      </div>
      <Button variant='elevated' size='md' onClick={() => window.location.reload()}>
        {t("block_error_reload")}
      </Button>
    </div>
  );
}
